import { render, staticRenderFns } from "./CloseTill.vue?vue&type=template&id=2ce52199&"
import script from "./CloseTill.vue?vue&type=script&lang=js&"
export * from "./CloseTill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports